
const initialState = {
  data: [],
  loading: false,
  success: false,
  error: false,
};

export const reportActivityProfileImage = () => (state = initialState, action) => {
  switch (action.type) {
    case `REPORT_ACTIVITY_PROFILE_IMAGE_REQUEST_REQUEST`: {
      return { ...initialState, data: state.data, loading: true };
    }
    case `REPORT_ACTIVITY_PROFILE_IMAGE_REQUEST_SUCCESS`: {
      return { ...state, data: [...state.data, action.data], success: false, loading: false };
    }
    case `REPORT_ACTIVITY_PROFILE_IMAGE_REQUEST_FAILURE`: {
      return { ...state, data: [], success: false, error: action.error, loading: false };
    }
    case `REPORT_ACTIVITY_PROFILE_IMAGE_REQUEST_RESET`: {
      return initialState;
    }
    default:
      return state;
  }
};
